const TYPES = {
  TEXT: "text",
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  URL: "url",
  CURRENCY: "currency"
};
const inputTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TYPES
}, Symbol.toStringTag, { value: "Module" }));
export {
  TYPES as T,
  inputTypes as i
};
//# sourceMappingURL=inputTypes-Cj9_-nL4.js.map
